<script setup>
import { ref, computed } from 'vue';
import TableDoctor from "./components/TableDataDoctor.vue";
import TableDataAdministrative from "./components/TableDataAdministrative";
const storedRoles = localStorage.getItem('rol');
const roles = ref(storedRoles ? JSON.parse(storedRoles) : []);

const hasProfessionalRole = computed(() => {
  return roles.value && roles.value.some(role => role.name === 'PROFESIONAL');
});

const hasPersonalRole = computed(() => {
  return roles.value && roles.value.some(role => role.name === 'PERSONAL');
});

</script>
<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <TableDoctor v-if="hasProfessionalRole" />
        <TableDataAdministrative v-if="hasPersonalRole" />
      </div>
    </div>
  </div>
</template>
